import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check, ShieldCheck, Download, Infinity, CreditCard, ChevronDown, Star, ArrowRight, AlertTriangle, BookOpen, Users, TrendingUp, Globe, Briefcase, FileText, HelpCircle, Lock, Zap, FileDown } from 'lucide-react';
import { SocialProofPopup } from './SocialProofPopup';
// Image URLs
const IMAGES = {
  MAIN: 'https://cdn.magicpatterns.com/uploads/uketLDEJsgVfL3jRt8eHtN/conjunto_de_mockups_turismo.png',
  BONUS1: 'https://cdn.magicpatterns.com/uploads/6JxosyVSZjXjLscaapUHyG/bonus_maletin_de_act.png',
  BONUS2: 'https://cdn.magicpatterns.com/uploads/xdCZarQDHvWmR8sHQbcS62/bonus_primeros_auxilios.png',
  BONUS3: 'https://cdn.magicpatterns.com/uploads/7jPddC3JCCs6g7bjXSoGJ3/bonus_planificacion_anual.png',
  UPSELL: 'https://cdn.magicpatterns.com/uploads/9J3MioKiq1fVGdgGA4X9rp/upsell_economia_.png'
};
// Links
const LINKS = {
  MAIN_CHECKOUT: 'https://checkout.kitonline.shop/cart/47772418834670:1',
  PREMIUM_CHECKOUT: 'https://checkout.kitonline.shop/cart/47772424012014:1',
  PREMIUM_PLUS_CHECKOUT: 'https://checkout.kitonline.shop/cart/47902703878382:1'
};
export function SalesPage() {
  const [openCuadernillo, setOpenCuadernillo] = useState<number | null>(null);
  const [openHoteleria, setOpenHoteleria] = useState<number | null>(null);
  const [selectedPack, setSelectedPack] = useState(1); // 0=main, 1=premium, 2=premium+
  const packLinks = [LINKS.MAIN_CHECKOUT, LINKS.PREMIUM_CHECKOUT, LINKS.PREMIUM_PLUS_CHECKOUT];
  // Urgency countdown (2h 13m 30s from page load)
  const [urgencyTime, setUrgencyTime] = useState({
    hours: 2,
    minutes: 13,
    seconds: 30
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setUrgencyTime(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        seconds--;
        if (seconds < 0) {
          seconds = 59;
          minutes--;
        }
        if (minutes < 0) {
          minutes = 59;
          hours--;
        }
        if (hours < 0) {
          hours = 0;
          minutes = 0;
          seconds = 0;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const scrollToPricing = () => {
    const element = document.getElementById('pricing');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="font-sans text-gray-900 bg-white min-h-screen flex flex-col" data-id="element-2">
      <SocialProofPopup data-id="element-3" />

      {/* SECTION 2: HERO */}
      <section className="bg-black py-3 md:py-10 px-3 md:px-4 text-center" data-id="element-4">
        <div className="max-w-4xl mx-auto" data-id="element-5">
          <span className="inline-block border border-[#22c55e] text-[#22c55e] text-[10px] md:text-sm font-bold uppercase tracking-widest mb-1.5 md:mb-3 px-3 py-0.5 rounded-full whitespace-nowrap" data-id="element-6">
            Para docentes de Turismo en secundaria
          </span>

          <h1 className="text-2xl md:text-5xl lg:text-6xl font-black text-white mb-1 md:mb-2 leading-tight" data-id="element-7">
            Todo tu año de turismo
            <br data-id="element-8" />
            organizado sin pasar horas
            <br data-id="element-9" />
            preparando clases
          </h1>

          <div onClick={scrollToPricing} className="cursor-pointer hover:opacity-95 transition-opacity my-1 md:my-4" data-id="element-10">
            <img src={IMAGES.MAIN} alt="Kit Completo Turismo Lista Mockup" className="w-full max-w-lg mx-auto drop-shadow-2xl" data-id="element-11" />
          </div>

          <p className="text-sm md:text-lg text-gray-300 mb-1.5 md:mb-3 max-w-2xl mx-auto" data-id="element-12">
            Un sistema completo para enseñar con contenido, actividades y
            evaluaciones listas desde el primer día
          </p>

          {/* Small badges above CTA */}
          <div className="flex justify-center gap-1.5 md:gap-3 mb-1.5 md:mb-2.5 flex-nowrap" data-id="element-13">
            <span className="flex items-center gap-1 border border-gray-600 text-gray-300 text-[10px] md:text-xs px-2 py-0.5 md:px-3 md:py-1 rounded-full whitespace-nowrap" data-id="element-14">
              <FileText className="w-2.5 h-2.5 md:w-3 md:h-3" data-id="element-15" /> 100% PDF
            </span>
            <span className="flex items-center gap-1 border border-gray-600 text-gray-300 text-[10px] md:text-xs px-2 py-0.5 md:px-3 md:py-1 rounded-full whitespace-nowrap" data-id="element-16">
              <Zap className="w-2.5 h-2.5 md:w-3 md:h-3" data-id="element-17" /> Acceso inmediato
            </span>
            <span className="flex items-center gap-1 border border-gray-600 text-gray-300 text-[10px] md:text-xs px-2 py-0.5 md:px-3 md:py-1 rounded-full whitespace-nowrap" data-id="element-18">
              🇦🇷 NAP 2026
            </span>
          </div>

          <button onClick={scrollToPricing} className="inline-flex items-center justify-center bg-[#22c55e] hover:bg-[#16a34a] text-white font-black text-sm md:text-xl py-2 px-5 md:py-2.5 md:px-8 rounded-xl shadow-[0_0_30px_rgba(34,197,94,0.3)] transform hover:scale-105 transition-all duration-200 mb-1.5 md:mb-2.5 whitespace-nowrap" data-id="element-19">
            → QUIERO MI KIT DE TURISMO AHORA
          </button>

          {/* Trust icons below CTA */}
          <div className="flex justify-center gap-2 md:gap-4 text-[10px] md:text-xs text-gray-500 font-medium flex-nowrap" data-id="element-20">
            <span className="flex items-center gap-0.5 whitespace-nowrap" data-id="element-21">
              <ShieldCheck className="w-3 h-3 md:w-3.5 md:h-3.5 text-green-500" data-id="element-22" />{' '}
              Garantía 7 días
            </span>
            <span className="flex items-center gap-0.5 whitespace-nowrap" data-id="element-23">
              <Lock className="w-3 h-3 md:w-3.5 md:h-3.5 text-green-500" data-id="element-24" /> Pago
              seguro
            </span>
            <span className="flex items-center gap-0.5 whitespace-nowrap" data-id="element-25">
              <CreditCard className="w-3 h-3 md:w-3.5 md:h-3.5 text-green-500" data-id="element-26" />{' '}
              Mercado Pago
            </span>
          </div>
        </div>
      </section>

      {/* SECTION 3: PAIN POINTS */}
      <section className="bg-gray-50 py-4 md:py-10 px-4 border-t border-gray-200" data-id="element-27">
        <div className="max-w-3xl mx-auto" data-id="element-28">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-2.5 md:mb-5" data-id="element-29">
            Si sos docente de Turismo, esto te va a sonar{' '}
            <span className="text-red-500 underline decoration-red-500/30 decoration-4 underline-offset-4" data-id="element-30">
              familiar…
            </span>
          </h2>

          <div className="space-y-2 md:space-y-3 text-base md:text-xl text-gray-700 leading-relaxed" data-id="element-31">
            <p data-id="element-32">
              ❌ Buscás material de turismo y encontrás contenidos genéricos que
              no se adaptan a la realidad argentina
            </p>
            <p data-id="element-33">
              ❌ Armás actividades desde cero porque no existe material
              organizado para secundaria
            </p>
            <p data-id="element-34">
              ❌ Tus alumnos preguntan "¿para qué sirve esto?" y no tenés
              ejemplos claros que los enganchen
            </p>
            <p data-id="element-35">
              ❌ Las planificaciones y evaluaciones te consumen horas que no
              tenés
            </p>
            <p data-id="element-36">
              ❌ Querés trabajar destinos, rutas turísticas, turismo sustentable
              y proyectos turísticos pero no tenés el material estructurado
            </p>
            <p className="font-bold text-gray-900" data-id="element-37">
              No es falta de capacidad. Es que te falta un sistema completo que
              te sostenga todo el año.
            </p>
          </div>
        </div>
      </section>

      {/* EXTRA STRATEGIC CTA */}
      <section className="bg-white py-2.5 md:py-5 px-4 text-center" data-id="element-38">
        <button onClick={scrollToPricing} className="bg-[#22c55e] hover:bg-[#16a34a] text-white font-bold text-lg md:text-2xl py-3 px-8 rounded-lg shadow-lg transform hover:scale-105 transition-all duration-200 w-full md:w-auto max-w-2xl" data-id="element-39">
          🔥 Quiero dejar de improvisar y tener todo resuelto
        </button>
      </section>

      {/* SECTION 4: SOLUTION */}
      <section className="bg-black text-white py-5 md:py-12 px-4 text-center" data-id="element-40">
        <div className="max-w-4xl mx-auto" data-id="element-41">
          <span className="inline-block bg-green-600 text-white text-xs font-bold px-3 py-0.5 rounded-full mb-2 md:mb-4 uppercase tracking-wider" data-id="element-42">
            La Solución
          </span>
          <h2 className="text-4xl md:text-6xl font-black mb-2 md:mb-4" data-id="element-43">
            KIT COMPLETO{' '}
            <span className="text-[#22c55e] underline decoration-[#22c55e]/30 decoration-4 underline-offset-8" data-id="element-44">
              TURISMO LISTA
            </span>
          </h2>
          <p className="text-xl md:text-2xl text-gray-300 mb-3 md:mb-6 max-w-3xl mx-auto" data-id="element-45">
            Sistema integral de clases, actividades, proyectos y evaluaciones
            diseñadas específicamente para turismo en secundaria.
          </p>

          <div className="flex flex-col items-center gap-2 text-lg md:text-xl font-bold text-white max-w-2xl mx-auto text-left" data-id="element-46">
            <span className="flex items-start gap-3 w-full" data-id="element-47">
              <Check className="w-6 h-6 text-[#22c55e] flex-shrink-0 mt-1" data-id="element-48" />
              <span data-id="element-49">
                Dar clases de turismo con material claro, organizado y listo
                para usar
              </span>
            </span>
            <span className="flex items-start gap-3 w-full" data-id="element-50">
              <Check className="w-6 h-6 text-[#22c55e] flex-shrink-0 mt-1" data-id="element-51" />
              <span data-id="element-52">
                Tener actividades y evaluaciones listas sin preparar nada
                adicional
              </span>
            </span>
            <span className="flex items-start gap-3 w-full" data-id="element-53">
              <Check className="w-6 h-6 text-[#22c55e] flex-shrink-0 mt-1" data-id="element-54" />
              <span data-id="element-55">
                Cumplir con los NAP 2026 y justificar ante directivos con
                rúbricas por capacidades
              </span>
            </span>
            <span className="flex items-start gap-3 w-full" data-id="element-56">
              <Check className="w-6 h-6 text-[#22c55e] flex-shrink-0 mt-1" data-id="element-57" />
              <span data-id="element-58">
                Conectar con tus alumnos usando ejemplos reales de destinos,
                circuitos turísticos y proyectos de desarrollo local
              </span>
            </span>
            <span className="flex items-start gap-3 w-full" data-id="element-59">
              <Check className="w-6 h-6 text-[#22c55e] flex-shrink-0 mt-1" data-id="element-60" />
              <span data-id="element-61">Ahorrar horas de trabajo cada semana</span>
            </span>
          </div>
        </div>
      </section>

      {/* EXTRA PERSUASIVE CTA */}
      <section className="bg-white py-3 md:py-6 px-4 text-center" data-id="element-62">
        <button onClick={scrollToPricing} className="bg-blue-600 hover:bg-blue-700 text-white font-black text-lg md:text-2xl py-3 px-8 rounded-xl shadow-[0_0_30px_rgba(37,99,235,0.3)] transform hover:scale-105 transition-all duration-200 w-full md:w-auto max-w-3xl" data-id="element-63">
          🚀 SÍ, QUIERO TRANSFORMAR MIS CLASES DE TURISMO
        </button>
      </section>

      {/* SECTION 5: CONTENTS */}
      <section className="bg-white py-5 md:py-12 px-4" data-id="element-64">
        <div className="max-w-4xl mx-auto" data-id="element-65">
          <div className="text-center mb-3 md:mb-6" data-id="element-66">
            <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-2" data-id="element-67">
              ¿QUÉ INCLUYE EL{' '}
              <span className="text-[#22c55e] underline decoration-[#22c55e]/30 decoration-4 underline-offset-4" data-id="element-68">
                KIT COMPLETO
              </span>{' '}
              TURISMO LISTA?
            </h2>
            <p className="text-xl text-gray-600 font-bold mb-2" data-id="element-69">
              360 páginas · 6 tomos · Alineado NAP 2026
            </p>
            <p className="text-lg text-gray-500" data-id="element-70">
              ✅ Tocá cada tomo para ver su contenido
            </p>
          </div>

          <div className="space-y-1.5 md:space-y-2" data-id="element-71">
            {/* Tomo 1 */}
            <div className="bg-gray-50 rounded-xl border border-gray-200 overflow-hidden transition-shadow hover:shadow-md" data-id="element-72">
              <button onClick={() => setOpenCuadernillo(openCuadernillo === 0 ? null : 0)} className="w-full flex items-center gap-3 p-3 md:p-5 text-left cursor-pointer" data-id="element-73">
                <BookOpen className="w-8 h-8 text-blue-600 flex-shrink-0" data-id="element-74" />
                <h3 className="text-lg md:text-xl font-bold text-gray-900 flex-1" data-id="element-75">
                  Tomo 1 — Introducción al Turismo
                </h3>
                <ChevronDown className={`w-6 h-6 text-gray-400 flex-shrink-0 transition-transform duration-300 ${openCuadernillo === 0 ? 'rotate-180' : ''}`} data-id="element-76" />
              </button>
              <AnimatePresence data-id="element-77">
                {openCuadernillo === 0 && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-78">
                    <div className="px-4 md:px-8 pb-4 md:pb-8 border-t border-gray-200 pt-4" data-id="element-79">
                      <ul className="space-y-2 md:space-y-3 text-gray-700 text-sm md:text-base" data-id="element-80">
                        <li className="flex items-start gap-2" data-id="element-81">
                          📘 Conceptos fundamentales del turismo
                        </li>
                        <li className="flex items-start gap-2" data-id="element-82">
                          📘 Evolución histórica del turismo
                        </li>
                        <li className="flex items-start gap-2" data-id="element-83">
                          📘 Importancia social y económica
                        </li>
                        <li className="flex items-start gap-2" data-id="element-84">
                          📘 Tipos de turismo
                        </li>
                        <li className="flex items-start gap-2" data-id="element-85">
                          📘 El turismo como actividad productiva
                        </li>
                        <li className="flex items-start gap-2" data-id="element-86">
                          📘 Marco legal del turismo en Argentina
                        </li>
                        <li className="flex items-start gap-2" data-id="element-87">
                          📘 Desarrollo conceptual claro y ordenado
                        </li>
                        <li className="flex items-start gap-2" data-id="element-88">
                          📘 Bibliografía y material de apoyo
                        </li>
                      </ul>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>

            {/* Tomo 2 */}
            <div className="bg-gray-50 rounded-xl border border-gray-200 overflow-hidden transition-shadow hover:shadow-md" data-id="element-89">
              <button onClick={() => setOpenCuadernillo(openCuadernillo === 1 ? null : 1)} className="w-full flex items-center gap-3 p-3 md:p-5 text-left cursor-pointer" data-id="element-90">
                <Globe className="w-8 h-8 text-green-600 flex-shrink-0" data-id="element-91" />
                <h3 className="text-lg md:text-xl font-bold text-gray-900 flex-1" data-id="element-92">
                  Tomo 2 — Geografía del Turismo
                </h3>
                <ChevronDown className={`w-6 h-6 text-gray-400 flex-shrink-0 transition-transform duration-300 ${openCuadernillo === 1 ? 'rotate-180' : ''}`} data-id="element-93" />
              </button>
              <AnimatePresence data-id="element-94">
                {openCuadernillo === 1 && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-95">
                    <div className="px-4 md:px-8 pb-4 md:pb-8 border-t border-gray-200 pt-4" data-id="element-96">
                      <ul className="space-y-2 md:space-y-3 text-gray-700 text-sm md:text-base" data-id="element-97">
                        <li className="flex items-start gap-2" data-id="element-98">
                          🗺️ Regiones turísticas argentinas
                        </li>
                        <li className="flex items-start gap-2" data-id="element-99">
                          🗺️ Paisajes y recursos naturales
                        </li>
                        <li className="flex items-start gap-2" data-id="element-100">
                          🗺️ Recursos culturales y patrimonio
                        </li>
                        <li className="flex items-start gap-2" data-id="element-101">
                          🗺️ Infraestructura turística
                        </li>
                        <li className="flex items-start gap-2" data-id="element-102">
                          🗺️ Organización del espacio turístico
                        </li>
                        <li className="flex items-start gap-2" data-id="element-103">
                          🗺️ Mapas y cartografía turística
                        </li>
                        <li className="flex items-start gap-2" data-id="element-104">
                          🗺️ Análisis de destinos nacionales
                        </li>
                        <li className="flex items-start gap-2" data-id="element-105">
                          🗺️ Bibliografía y recursos didácticos
                        </li>
                      </ul>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>

            {/* Tomo 3 */}
            <div className="bg-gray-50 rounded-xl border border-gray-200 overflow-hidden transition-shadow hover:shadow-md" data-id="element-106">
              <button onClick={() => setOpenCuadernillo(openCuadernillo === 2 ? null : 2)} className="w-full flex items-center gap-3 p-3 md:p-5 text-left cursor-pointer" data-id="element-107">
                <TrendingUp className="w-8 h-8 text-orange-600 flex-shrink-0" data-id="element-108" />
                <h3 className="text-lg md:text-xl font-bold text-gray-900 flex-1" data-id="element-109">
                  Tomo 3 — Economía del Turismo
                </h3>
                <ChevronDown className={`w-6 h-6 text-gray-400 flex-shrink-0 transition-transform duration-300 ${openCuadernillo === 2 ? 'rotate-180' : ''}`} data-id="element-110" />
              </button>
              <AnimatePresence data-id="element-111">
                {openCuadernillo === 2 && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-112">
                    <div className="px-4 md:px-8 pb-4 md:pb-8 border-t border-gray-200 pt-4" data-id="element-113">
                      <ul className="space-y-2 md:space-y-3 text-gray-700 text-sm md:text-base" data-id="element-114">
                        <li className="flex items-start gap-2" data-id="element-115">
                          📙 Oferta y demanda turística
                        </li>
                        <li className="flex items-start gap-2" data-id="element-116">
                          📙 Servicios turísticos
                        </li>
                        <li className="flex items-start gap-2" data-id="element-117">
                          📙 Empleo en el sector turismo
                        </li>
                        <li className="flex items-start gap-2" data-id="element-118">
                          📙 Funcionamiento de la industria turística
                        </li>
                        <li className="flex items-start gap-2" data-id="element-119">
                          📙 Cadena de valor del turismo
                        </li>
                        <li className="flex items-start gap-2" data-id="element-120">
                          📙 Impacto económico del turismo
                        </li>
                        <li className="flex items-start gap-2" data-id="element-121">
                          📙 Estadísticas y datos del sector
                        </li>
                        <li className="flex items-start gap-2" data-id="element-122">
                          📙 Bibliografía y actividades sugeridas
                        </li>
                      </ul>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>

            {/* Tomo 4 */}
            <div className="bg-gray-50 rounded-xl border border-gray-200 overflow-hidden transition-shadow hover:shadow-md" data-id="element-123">
              <button onClick={() => setOpenCuadernillo(openCuadernillo === 3 ? null : 3)} className="w-full flex items-center gap-3 p-3 md:p-5 text-left cursor-pointer" data-id="element-124">
                <Users className="w-8 h-8 text-rose-600 flex-shrink-0" data-id="element-125" />
                <h3 className="text-lg md:text-xl font-bold text-gray-900 flex-1" data-id="element-126">
                  Tomo 4 — Turismo Sustentable
                </h3>
                <ChevronDown className={`w-6 h-6 text-gray-400 flex-shrink-0 transition-transform duration-300 ${openCuadernillo === 3 ? 'rotate-180' : ''}`} data-id="element-127" />
              </button>
              <AnimatePresence data-id="element-128">
                {openCuadernillo === 3 && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-129">
                    <div className="px-4 md:px-8 pb-4 md:pb-8 border-t border-gray-200 pt-4" data-id="element-130">
                      <ul className="space-y-2 md:space-y-3 text-gray-700 text-sm md:text-base" data-id="element-131">
                        <li className="flex items-start gap-2" data-id="element-132">
                          🌿 Impacto ambiental del turismo
                        </li>
                        <li className="flex items-start gap-2" data-id="element-133">
                          🌿 Conservación del patrimonio
                        </li>
                        <li className="flex items-start gap-2" data-id="element-134">
                          🌿 Turismo responsable
                        </li>
                        <li className="flex items-start gap-2" data-id="element-135">
                          🌿 Modelos de desarrollo sostenible
                        </li>
                        <li className="flex items-start gap-2" data-id="element-136">
                          🌿 Ecoturismo y turismo comunitario
                        </li>
                        <li className="flex items-start gap-2" data-id="element-137">
                          🌿 Certificaciones ambientales
                        </li>
                        <li className="flex items-start gap-2" data-id="element-138">
                          🌿 Casos de estudio argentinos
                        </li>
                        <li className="flex items-start gap-2" data-id="element-139">
                          🌿 Bibliografía y material de referencia
                        </li>
                      </ul>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>

            {/* Tomo 5 */}
            <div className="bg-gray-50 rounded-xl border border-gray-200 overflow-hidden transition-shadow hover:shadow-md" data-id="element-140">
              <button onClick={() => setOpenCuadernillo(openCuadernillo === 4 ? null : 4)} className="w-full flex items-center gap-3 p-3 md:p-5 text-left cursor-pointer" data-id="element-141">
                <Briefcase className="w-8 h-8 text-yellow-600 flex-shrink-0" data-id="element-142" />
                <h3 className="text-lg md:text-xl font-bold text-gray-900 flex-1" data-id="element-143">
                  Tomo 5 — Planificación Turística
                </h3>
                <ChevronDown className={`w-6 h-6 text-gray-400 flex-shrink-0 transition-transform duration-300 ${openCuadernillo === 4 ? 'rotate-180' : ''}`} data-id="element-144" />
              </button>
              <AnimatePresence data-id="element-145">
                {openCuadernillo === 4 && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-146">
                    <div className="px-4 md:px-8 pb-4 md:pb-8 border-t border-gray-200 pt-4" data-id="element-147">
                      <ul className="space-y-2 md:space-y-3 text-gray-700 text-sm md:text-base" data-id="element-148">
                        <li className="flex items-start gap-2" data-id="element-149">
                          📒 Identificación de recursos turísticos
                        </li>
                        <li className="flex items-start gap-2" data-id="element-150">
                          📒 Diseño de circuitos turísticos
                        </li>
                        <li className="flex items-start gap-2" data-id="element-151">
                          📒 Promoción de destinos
                        </li>
                        <li className="flex items-start gap-2" data-id="element-152">
                          📒 Desarrollo local y turismo
                        </li>
                        <li className="flex items-start gap-2" data-id="element-153">
                          📒 Marketing turístico básico
                        </li>
                        <li className="flex items-start gap-2" data-id="element-154">
                          📒 Gestión de destinos
                        </li>
                        <li className="flex items-start gap-2" data-id="element-155">
                          📒 Herramientas de planificación
                        </li>
                        <li className="flex items-start gap-2" data-id="element-156">
                          📒 Bibliografía y recursos
                        </li>
                      </ul>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>

            {/* Tomo 6 */}
            <div className="bg-gray-50 rounded-xl border border-gray-200 overflow-hidden transition-shadow hover:shadow-md" data-id="element-157">
              <button onClick={() => setOpenCuadernillo(openCuadernillo === 5 ? null : 5)} className="w-full flex items-center gap-3 p-3 md:p-5 text-left cursor-pointer" data-id="element-158">
                <FileText className="w-8 h-8 text-purple-600 flex-shrink-0" data-id="element-159" />
                <h3 className="text-lg md:text-xl font-bold text-gray-900 flex-1" data-id="element-160">
                  Tomo 6 — Proyecto Turístico Escolar
                </h3>
                <ChevronDown className={`w-6 h-6 text-gray-400 flex-shrink-0 transition-transform duration-300 ${openCuadernillo === 5 ? 'rotate-180' : ''}`} data-id="element-161" />
              </button>
              <AnimatePresence data-id="element-162">
                {openCuadernillo === 5 && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-163">
                    <div className="px-4 md:px-8 pb-4 md:pb-8 border-t border-gray-200 pt-4" data-id="element-164">
                      <ul className="space-y-2 md:space-y-3 text-gray-700 text-sm md:text-base" data-id="element-165">
                        <li className="flex items-start gap-2" data-id="element-166">
                          📓 Diseño de proyectos turísticos
                        </li>
                        <li className="flex items-start gap-2" data-id="element-167">
                          📓 Investigación turística en el aula
                        </li>
                        <li className="flex items-start gap-2" data-id="element-168">
                          📓 Planificación de proyectos
                        </li>
                        <li className="flex items-start gap-2" data-id="element-169">
                          📓 Presentación final de proyectos
                        </li>
                        <li className="flex items-start gap-2" data-id="element-170">
                          📓 Trabajo en equipo y roles
                        </li>
                        <li className="flex items-start gap-2" data-id="element-171">
                          📓 Evaluación de proyectos
                        </li>
                        <li className="flex items-start gap-2" data-id="element-172">
                          📓 Guía paso a paso
                        </li>
                        <li className="flex items-start gap-2" data-id="element-173">
                          📓 Rúbricas de evaluación
                        </li>
                      </ul>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 8: BONUSES */}
      <section className="py-5 md:py-12 px-4" style={{
      background: 'linear-gradient(180deg, #080c1a 0%, #0d1229 100%)'
    }} data-id="element-174">
        <div className="max-w-5xl mx-auto" data-id="element-175">
          {/* Header */}
          <div className="text-center mb-4 md:mb-6" data-id="element-176">
            <h2 className="text-3xl md:text-5xl font-black text-white mb-2 leading-tight" data-id="element-177">
              <span className="text-[#22c55e]" data-id="element-178">BONUS</span> exclusivos incluidos
              con tu compra
            </h2>

            {/* Red CTA Banner */}
            <div className="inline-flex items-center gap-2 bg-red-600 text-white font-black text-base md:text-xl px-6 md:px-10 py-2 md:py-3 rounded-lg shadow-[0_0_30px_rgba(220,38,38,0.4)] mb-4 md:mb-6" data-id="element-179">
              <span className="text-xl md:text-2xl" data-id="element-180">🎁</span>
              ¡GRATIS POR EL DÍA DE HOY!
            </div>
          </div>

          {/* Bonus Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-2 md:gap-3 mb-3 md:mb-6" data-id="element-181">
            {/* Bonus 1 */}
            <div className="relative bg-[#111633] rounded-lg border border-[#1e2a5a] overflow-hidden p-3 md:p-5 flex flex-col" data-id="element-182">
              <span className="absolute top-1 right-2 text-[50px] md:text-[80px] font-black text-white/[0.04] leading-none select-none pointer-events-none" data-id="element-183">
                01
              </span>
              <span className="inline-block bg-red-600 text-white text-[10px] md:text-xs font-bold px-2.5 py-0.5 rounded-full uppercase tracking-wider mb-2 self-start" data-id="element-184">
                BONO #01
              </span>
              <h3 className="text-lg md:text-xl font-bold text-white mb-1.5" data-id="element-185">
                📋 Planificación Anual de Turismo
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed flex-1" data-id="element-186">
                Planificación anual completa para la materia turismo. Incluye
                objetivos, contenidos por unidad, actividades sugeridas y
                criterios de evaluación listos para presentar y usar en clase.
              </p>
              <div className="flex items-center justify-between mt-3 pt-2.5 border-t border-white/10" data-id="element-187">
                <span className="text-gray-500 text-sm line-through" data-id="element-188">
                  Valor $8.500
                </span>
                <span className="bg-[#22c55e] text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-189">
                  GRATIS
                </span>
              </div>
            </div>

            {/* Bonus 2 */}
            <div className="relative bg-[#111633] rounded-lg border border-[#1e2a5a] overflow-hidden p-3 md:p-5 flex flex-col" data-id="element-190">
              <span className="absolute top-1 right-2 text-[50px] md:text-[80px] font-black text-white/[0.04] leading-none select-none pointer-events-none" data-id="element-191">
                02
              </span>
              <span className="inline-block bg-yellow-500 text-black text-[10px] md:text-xs font-bold px-2.5 py-0.5 rounded-full uppercase tracking-wider mb-2 self-start" data-id="element-192">
                BONO #02
              </span>
              <h3 className="text-lg md:text-xl font-bold text-white mb-1.5" data-id="element-193">
                📘 120 Actividades de Turismo para el Aula
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed flex-1" data-id="element-194">
                Banco de actividades listas para usar: análisis de destinos,
                diseño de circuitos turísticos, debates, trabajos grupales y
                actividades prácticas para secundaria.
              </p>
              <div className="flex items-center justify-between mt-3 pt-2.5 border-t border-white/10" data-id="element-195">
                <span className="text-gray-500 text-sm line-through" data-id="element-196">
                  Valor $8.500
                </span>
                <span className="bg-[#22c55e] text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-197">
                  GRATIS
                </span>
              </div>
            </div>

            {/* Bonus 3 */}
            <div className="relative bg-[#111633] rounded-lg border border-[#1e2a5a] overflow-hidden p-3 md:p-5 flex flex-col" data-id="element-198">
              <span className="absolute top-1 right-2 text-[50px] md:text-[80px] font-black text-white/[0.04] leading-none select-none pointer-events-none" data-id="element-199">
                03
              </span>
              <span className="inline-block bg-red-600 text-white text-[10px] md:text-xs font-bold px-2.5 py-0.5 rounded-full uppercase tracking-wider mb-2 self-start" data-id="element-200">
                BONO #03
              </span>
              <h3 className="text-lg md:text-xl font-bold text-white mb-1.5" data-id="element-201">
                ✨ Sistema PRO de Evaluación en Turismo
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed flex-1" data-id="element-202">
                Evaluaciones diagnósticas, rúbricas de corrección, evaluaciones
                integradoras y herramientas para evaluar proyectos turísticos en
                el aula.
              </p>
              <div className="flex items-center justify-between mt-3 pt-2.5 border-t border-white/10" data-id="element-203">
                <span className="text-gray-500 text-sm line-through" data-id="element-204">
                  Valor $8.000
                </span>
                <span className="bg-[#22c55e] text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-205">
                  GRATIS
                </span>
              </div>
            </div>
          </div>

          {/* Total Value Summary Box */}
          <div className="max-w-md mx-auto bg-[#111633] border border-[#1e2a5a] rounded-2xl p-3 md:p-5 text-center" data-id="element-206">
            <p className="text-gray-400 text-base mb-2" data-id="element-207">
              Valor total de los 3 bonus:
            </p>
            <p className="text-white text-2xl md:text-3xl font-black line-through decoration-red-500 decoration-2 mb-2 md:mb-4" data-id="element-208">
              $25.000
            </p>
            <p className="text-gray-400 text-base mb-2" data-id="element-209">
              Hoy te los llevás por:
            </p>
            <p className="text-[#22c55e] text-4xl md:text-6xl font-black mb-2 md:mb-4" data-id="element-210">
              $0
            </p>
            <p className="text-[#22c55e] font-bold text-sm md:text-base" data-id="element-211">
              ✨ Incluidos GRATIS con tu compra de hoy ✨
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 8.5: URGENCY */}
      <section className="py-5 md:py-12 px-4" style={{
      background: 'linear-gradient(180deg, #0d1229 0%, #0a0e1a 100%)'
    }} data-id="element-212">
        <div className="max-w-3xl mx-auto text-center" data-id="element-213">
          {/* Title */}
          <h2 className="text-2xl md:text-4xl font-black text-yellow-400 mb-3 md:mb-6 uppercase tracking-wide" data-id="element-214">
            El precio de lanzamiento termina en
          </h2>

          {/* Countdown boxes */}
          <div className="flex items-center justify-center gap-2 md:gap-4 mb-4 md:mb-6" data-id="element-215">
            <div className="flex flex-col items-center" data-id="element-216">
              <div className="bg-red-700 border-2 border-red-500 rounded-xl w-14 h-14 md:w-24 md:h-24 flex items-center justify-center shadow-[0_0_20px_rgba(220,38,38,0.4)]" data-id="element-217">
                <span className="text-white text-3xl md:text-6xl font-black" data-id="element-218">
                  {String(urgencyTime.hours).padStart(2, '0')}
                </span>
              </div>
              <span className="text-gray-500 text-xs md:text-sm font-bold uppercase tracking-wider mt-2" data-id="element-219">
                Horas
              </span>
            </div>
            <span className="text-red-500 text-3xl md:text-6xl font-black -mt-6" data-id="element-220">
              :
            </span>
            <div className="flex flex-col items-center" data-id="element-221">
              <div className="bg-red-700 border-2 border-red-500 rounded-xl w-14 h-14 md:w-24 md:h-24 flex items-center justify-center shadow-[0_0_20px_rgba(220,38,38,0.4)]" data-id="element-222">
                <span className="text-white text-3xl md:text-6xl font-black" data-id="element-223">
                  {String(urgencyTime.minutes).padStart(2, '0')}
                </span>
              </div>
              <span className="text-gray-500 text-xs md:text-sm font-bold uppercase tracking-wider mt-2" data-id="element-224">
                Minutos
              </span>
            </div>
            <span className="text-red-500 text-3xl md:text-6xl font-black -mt-6" data-id="element-225">
              :
            </span>
            <div className="flex flex-col items-center" data-id="element-226">
              <div className="bg-red-700 border-2 border-red-500 rounded-xl w-14 h-14 md:w-24 md:h-24 flex items-center justify-center shadow-[0_0_20px_rgba(220,38,38,0.4)]" data-id="element-227">
                <span className="text-white text-3xl md:text-6xl font-black" data-id="element-228">
                  {String(urgencyTime.seconds).padStart(2, '0')}
                </span>
              </div>
              <span className="text-gray-500 text-xs md:text-sm font-bold uppercase tracking-wider mt-2" data-id="element-229">
                Segundos
              </span>
            </div>
          </div>

          {/* Info badges */}
          <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-3 md:mb-6" data-id="element-230">
            <span className="flex items-center gap-1.5 bg-[#111633] border border-[#1e2a5a] text-gray-300 text-xs md:text-sm font-medium px-3 py-1.5 rounded-lg" data-id="element-231">
              🔥 Últimas unidades disponibles
            </span>
            <span className="flex items-center gap-1.5 bg-[#111633] border border-[#1e2a5a] text-gray-300 text-xs md:text-sm font-medium px-3 py-1.5 rounded-lg" data-id="element-232">
              📢 Oferta de Lanzamiento
            </span>
            <span className="flex items-center gap-1.5 bg-[#111633] border border-[#1e2a5a] text-gray-300 text-xs md:text-sm font-medium px-3 py-1.5 rounded-lg" data-id="element-233">
              📈 Precio sube al terminar
            </span>
          </div>

          {/* Progress bar */}
          <div className="max-w-lg mx-auto mb-3 md:mb-6" data-id="element-234">
            <div className="relative w-full h-5 bg-gray-800 rounded-full overflow-hidden border border-gray-700" data-id="element-235">
              <div className="h-full rounded-full" style={{
              width: '72%',
              background: 'linear-gradient(90deg, #f97316 0%, #ef4444 60%, #dc2626 100%)'
            }} data-id="element-236" />
            </div>
            <p className="text-gray-400 text-sm font-bold mt-3 uppercase tracking-wider" data-id="element-237">
              72 % de cupos ocupados
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 9: PRICING */}
      <section id="pricing" className="py-5 md:py-12 px-4" style={{
      background: 'linear-gradient(180deg, #080c1a 0%, #0d1229 50%, #080c1a 100%)'
    }} data-id="element-238">
        <div className="max-w-5xl mx-auto" data-id="element-239">
          {/* Title */}
          <h2 className="text-3xl md:text-5xl font-black text-white text-center mb-6 md:mb-12 italic" data-id="element-240">
            Elegí tu{' '}
            <span className="text-[#22c55e] underline decoration-[#22c55e]/30 decoration-4 underline-offset-8" data-id="element-241">
              Pack Completo
            </span>
          </h2>

          {/* Pack Cards - 3 Options */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 mb-6 md:mb-10 max-w-5xl mx-auto" data-id="element-242">
            {/* Card 0: Kit Turismo */}
            <button onClick={() => setSelectedPack(0)} className={`relative text-left rounded-xl p-5 md:p-8 transition-all duration-200 cursor-pointer ${selectedPack === 0 ? 'bg-[#111633] border-2 border-[#22c55e] shadow-[0_0_20px_rgba(34,197,94,0.15)]' : 'bg-[#0d1025] border-2 border-[#1e2a5a] hover:border-[#2a3a6a]'}`} data-id="element-243">
              <div className={`absolute top-4 right-4 w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex items-center justify-center ${selectedPack === 0 ? 'border-[#22c55e] bg-[#22c55e]' : 'border-gray-600'}`} data-id="element-244">
                {selectedPack === 0 && <Check className="w-3 h-3 md:w-4 md:h-4 text-white" data-id="element-245" />}
              </div>
              <div className="text-3xl mb-2" data-id="element-246">✈️</div>
              <h3 className="text-lg md:text-2xl font-black text-white mb-1 pr-6" data-id="element-247">
                KIT COMPLETO DE TURISMO
              </h3>
              <p className="text-gray-500 text-xs md:text-sm mb-3" data-id="element-248">
                Para Docentes de Secundaria Argentina — Edición 2026
              </p>
              <ul className="space-y-2 mb-4" data-id="element-249">
                <li className="flex items-start gap-2 text-gray-300 text-xs md:text-sm" data-id="element-250">
                  <Check className="w-4 h-4 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-251" />
                  6 Tomos completos
                </li>
                <li className="flex items-start gap-2 text-gray-300 text-xs md:text-sm" data-id="element-252">
                  <Check className="w-4 h-4 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-253" />
                  3 Bonus incluidos
                </li>
                <li className="flex items-start gap-2 text-gray-300 text-xs md:text-sm" data-id="element-254">
                  <Check className="w-4 h-4 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-255" />
                  Acceso Inmediato
                </li>
              </ul>
              <div className="flex items-baseline gap-2" data-id="element-256">
                <span className="text-3xl md:text-5xl font-black text-white" data-id="element-257">
                  $19.990
                </span>
              </div>
              <span className="text-gray-600 text-sm line-through" data-id="element-258">
                $39.990
              </span>
            </button>

            {/* Card 1: Kit + Proyecto */}
            <button onClick={() => setSelectedPack(1)} className={`relative text-left rounded-xl p-5 md:p-8 transition-all duration-200 cursor-pointer ${selectedPack === 1 ? 'bg-[#111633] border-2 border-[#22c55e] shadow-[0_0_20px_rgba(34,197,94,0.15)]' : 'bg-[#0d1025] border-2 border-[#1e2a5a] hover:border-[#2a3a6a]'}`} data-id="element-259">
              <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-blue-600 text-white text-[10px] md:text-sm font-bold px-3 py-1 rounded-full uppercase tracking-wider whitespace-nowrap shadow-lg" data-id="element-260">
                Oferta especial
              </span>
              <div className={`absolute top-4 right-4 w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex items-center justify-center ${selectedPack === 1 ? 'border-[#22c55e] bg-[#22c55e]' : 'border-gray-600'}`} data-id="element-261">
                {selectedPack === 1 && <Check className="w-3 h-3 md:w-4 md:h-4 text-white" data-id="element-262" />}
              </div>
              <div className="text-3xl mb-2" data-id="element-263">👑</div>
              <h3 className="text-lg md:text-2xl font-black text-white mb-1 pr-6" data-id="element-264">
                KIT COMPLETO + PROYECTO TURÍSTICO 2026
              </h3>
              <p className="text-gray-500 text-xs md:text-sm mb-3" data-id="element-265">
                El Sistema de Desarrollo de Proyectos Turísticos para tu Aula
              </p>
              <ul className="space-y-2 mb-4" data-id="element-266">
                <li className="flex items-start gap-2 text-gray-300 text-xs md:text-sm" data-id="element-267">
                  <Check className="w-4 h-4 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-268" />
                  6 Tomos completos
                </li>
                <li className="flex items-start gap-2 text-gray-300 text-xs md:text-sm" data-id="element-269">
                  <Check className="w-4 h-4 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-270" />
                  3 Bonus incluidos
                </li>
                <li className="flex items-start gap-2 text-gray-300 text-xs md:text-sm" data-id="element-271">
                  <Check className="w-4 h-4 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-272" />
                  Sistema de Proyectos Turísticos
                </li>
              </ul>
              <div className="flex items-baseline gap-2" data-id="element-273">
                <span className="text-3xl md:text-5xl font-black text-white" data-id="element-274">
                  $27.990
                </span>
              </div>
              <span className="text-gray-600 text-sm line-through" data-id="element-275">
                $49.990
              </span>
            </button>

            {/* Card 2: Pack Premium + Hotelería */}
            <button onClick={() => setSelectedPack(2)} className={`relative text-left rounded-xl p-5 md:p-8 transition-all duration-200 cursor-pointer ${selectedPack === 2 ? 'bg-[#111633] border-2 border-[#22c55e] shadow-[0_0_20px_rgba(34,197,94,0.15)]' : 'bg-[#0d1025] border-2 border-[#1e2a5a] hover:border-[#2a3a6a]'}`} data-id="element-276">
              <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-red-600 text-white text-[10px] md:text-sm font-bold px-3 py-1 rounded-full uppercase tracking-wider whitespace-nowrap shadow-lg" data-id="element-277">
                🔥 Pack Premium +
              </span>
              <div className={`absolute top-4 right-4 w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex items-center justify-center ${selectedPack === 2 ? 'border-[#22c55e] bg-[#22c55e]' : 'border-gray-600'}`} data-id="element-278">
                {selectedPack === 2 && <Check className="w-3 h-3 md:w-4 md:h-4 text-white" data-id="element-279" />}
              </div>
              <div className="text-3xl mb-2" data-id="element-280">💎</div>
              <h3 className="text-lg md:text-2xl font-black text-white mb-1 pr-6" data-id="element-281">
                KIT COMPLETO TURISMO + KIT COMPLETO HOTELERÍA
              </h3>
              <p className="text-gray-500 text-xs md:text-sm mb-3" data-id="element-282">
                Todo el Kit Completo de Turismo + Hotelería Lista
              </p>
              <ul className="space-y-2 mb-4" data-id="element-283">
                <li className="flex items-start gap-2 text-gray-300 text-xs md:text-sm" data-id="element-284">
                  <Check className="w-4 h-4 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-285" />
                  12 Tomos completos
                </li>
                <li className="flex items-start gap-2 text-gray-300 text-xs md:text-sm" data-id="element-286">
                  7 Bonus incluidos
                </li>
                <li className="flex items-start gap-2 text-gray-300 text-xs md:text-sm" data-id="element-287">
                  <Check className="w-4 h-4 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-288" />
                  2 Upsell exclusivos
                </li>
              </ul>
              <div className="flex items-baseline gap-2" data-id="element-289">
                <span className="text-3xl md:text-5xl font-black text-white" data-id="element-290">
                  $38.990
                </span>
              </div>
              <span className="text-gray-600 text-sm line-through" data-id="element-291">
                $59.990
              </span>
            </button>
          </div>

          {/* CTA Button */}
          <div className="text-center mb-4 md:mb-6" data-id="element-292">
            <a href={packLinks[selectedPack]} className="inline-flex items-center justify-center gap-2 w-full md:w-auto bg-[#22c55e] hover:bg-[#16a34a] text-white font-black text-xl md:text-3xl py-4 px-8 md:py-5 md:px-16 rounded-xl shadow-[0_0_30px_rgba(34,197,94,0.3)] transform hover:scale-[1.02] transition-all duration-200" data-id="element-293">
              Sí, quiero mi pack →
            </a>
            <p className="text-gray-500 text-sm md:text-base font-medium mt-2 flex items-center justify-center gap-2" data-id="element-294">
              <Lock className="w-4 h-4" data-id="element-295" /> PAGO SEGURO CON MERCADO PAGO
            </p>
          </div>

          {/* Features Box */}
          

          {/* Payment methods */}
          <p className="text-center text-gray-600 text-sm md:text-base mt-3 md:mt-5 flex items-center justify-center gap-2" data-id="element-296">
            <CreditCard className="w-5 h-5" data-id="element-297" />
            Transferencia · Mercado Pago · Tarjeta
          </p>
        </div>
      </section>

      {/* SECTION: HOTELERÍA CONTENTS */}
      <section className="bg-white py-5 md:py-12 px-4" data-id="element-298">
        <div className="max-w-4xl mx-auto" data-id="element-299">
          <div className="text-center mb-3 md:mb-6" data-id="element-300">
            <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-2" data-id="element-301">
              ¿Qué trae el{' '}
              <span className="text-[#22c55e] underline decoration-[#22c55e]/30 decoration-4 underline-offset-4" data-id="element-302">
                Kit Completo Hotelería
              </span>
              ?
            </h2>
          </div>

          <div className="max-w-2xl mx-auto bg-gray-50 rounded-2xl border border-gray-200 overflow-hidden" data-id="element-303">
            <button onClick={() => setOpenHoteleria(openHoteleria === 0 ? null : 0)} className="w-full flex items-center gap-3 p-4 md:p-6 text-left cursor-pointer hover:bg-gray-100 transition-colors" data-id="element-304">
              <span className="text-3xl flex-shrink-0" data-id="element-305">🏨</span>
              <h3 className="text-xl md:text-2xl font-black text-gray-900 flex-1" data-id="element-306">
                Kit Completo Hotelería
              </h3>
              <ChevronDown className={`w-6 h-6 text-gray-400 flex-shrink-0 transition-transform duration-300 ${openHoteleria === 0 ? 'rotate-180' : ''}`} data-id="element-307" />
            </button>
            <AnimatePresence data-id="element-308">
              {openHoteleria === 0 && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-309">
                  <div className="px-5 md:px-8 pb-5 md:pb-8 border-t border-gray-200 pt-4" data-id="element-310">
                    <ul className="space-y-2.5" data-id="element-311">
                      {[{
                    icon: '📘',
                    text: 'Tomo 1: Introducción a la hotelería'
                  }, {
                    icon: '📗',
                    text: 'Tomo 2: Organización del hotel'
                  }, {
                    icon: '📙',
                    text: 'Tomo 3: Atención al cliente'
                  }, {
                    icon: '📕',
                    text: 'Tomo 4: Operaciones (check-in / check-out)'
                  }, {
                    icon: '📒',
                    text: 'Tomo 5: Higiene y seguridad'
                  }, {
                    icon: '📓',
                    text: 'Tomo 6: Hotelería y salida laboral'
                  }, {
                    icon: '🎁',
                    text: 'Bonus 1: Planificación anual'
                  }, {
                    icon: '🎁',
                    text: 'Bonus 2: Banco de actividades'
                  }, {
                    icon: '🎁',
                    text: 'Bonus 3: Sistema de evaluación'
                  }, {
                    icon: '🎁',
                    text: 'Bonus 4: Simulaciones hoteleras'
                  }, {
                    icon: '⭐',
                    text: 'Upsell: Simulación hotelera avanzada + evaluación profesional'
                  }].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-700 text-sm md:text-base" data-id="element-312">
                          <span className="text-lg flex-shrink-0" data-id="element-313">
                            {item.icon}
                          </span>
                          {item.text}
                        </li>)}
                    </ul>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>

          <div className="text-center mt-4 md:mt-6" data-id="element-314">
            <button onClick={scrollToPricing} className="inline-flex items-center justify-center gap-2 bg-[#22c55e] hover:bg-[#16a34a] text-white font-black text-lg md:text-2xl py-3 px-8 md:py-4 md:px-12 rounded-xl shadow-[0_0_30px_rgba(34,197,94,0.3)] transform hover:scale-[1.02] transition-all duration-200" data-id="element-315">
              Sí, quiero mi pack →
            </button>
          </div>
        </div>
      </section>

      {/* SECTION 10: HOW IT WORKS */}
      <section className="bg-white py-3 md:py-8 px-4" data-id="element-316">
        <div className="max-w-3xl mx-auto text-center" data-id="element-317">
          <h2 className="text-xl md:text-3xl font-bold text-gray-900 mb-2 md:mb-5" data-id="element-318">
            🔽 ¿Cómo recibís el{' '}
            <span className="text-[#22c55e] underline decoration-[#22c55e]/30 decoration-4 underline-offset-4" data-id="element-319">
              material
            </span>
            ?
          </h2>

          <div className="grid grid-cols-3 gap-2 md:gap-6" data-id="element-320">
            <div className="relative" data-id="element-321">
              <div className="w-9 h-9 md:w-14 md:h-14 bg-gray-100 rounded-full flex items-center justify-center text-base md:text-2xl font-bold text-gray-900 mx-auto mb-1 md:mb-3 border-2 border-gray-200" data-id="element-322">
                1
              </div>
              <h3 className="text-xs md:text-lg font-bold text-gray-900 mb-0.5 md:mb-2" data-id="element-323">
                Comprás
              </h3>
              <p className="text-gray-600 text-[11px] md:text-base leading-tight" data-id="element-324">
                Realizás la compra e ingresás tu correo.
              </p>
            </div>
            <div className="relative" data-id="element-325">
              <div className="w-9 h-9 md:w-14 md:h-14 bg-gray-100 rounded-full flex items-center justify-center text-base md:text-2xl font-bold text-gray-900 mx-auto mb-1 md:mb-3 border-2 border-gray-200" data-id="element-326">
                2
              </div>
              <h3 className="text-xs md:text-lg font-bold text-gray-900 mb-0.5 md:mb-2" data-id="element-327">
                Pagás
              </h3>
              <p className="text-gray-600 text-[11px] md:text-base leading-tight" data-id="element-328">
                Finalizás el pago de forma segura.
              </p>
            </div>
            <div className="relative" data-id="element-329">
              <div className="w-9 h-9 md:w-14 md:h-14 bg-gray-100 rounded-full flex items-center justify-center text-base md:text-2xl font-bold text-gray-900 mx-auto mb-1 md:mb-3 border-2 border-gray-200" data-id="element-330">
                3
              </div>
              <h3 className="text-xs md:text-lg font-bold text-gray-900 mb-0.5 md:mb-2" data-id="element-331">
                Descargás
              </h3>
              <p className="text-gray-600 text-[11px] md:text-base leading-tight" data-id="element-332">
                Recibís el link de descarga en tu correo.
              </p>
            </div>
          </div>

          <div className="mt-3 md:mt-8 bg-yellow-50 border border-yellow-200 rounded-lg p-2 md:p-4 inline-block" data-id="element-333">
            <p className="text-yellow-800 flex items-center justify-center gap-1.5 font-medium text-xs md:text-base" data-id="element-334">
              <AlertTriangle className="w-3.5 h-3.5 md:w-5 md:h-5" data-id="element-335" />
              Si no lo ves en tu bandeja, revisá spam.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 12: GUARANTEE */}
      <section className="bg-white py-5 md:py-10 px-4 border-t border-gray-100" data-id="element-336">
        <div className="max-w-3xl mx-auto text-center" data-id="element-337">
          <ShieldCheck className="w-12 h-12 md:w-16 md:h-16 text-[#22c55e] mx-auto mb-2 md:mb-4" data-id="element-338" />
          <h2 className="text-3xl font-bold text-gray-900 mb-1.5 md:mb-3" data-id="element-339">
            Garantía de{' '}
            <span className="text-[#22c55e] underline decoration-[#22c55e]/30 decoration-4 underline-offset-4" data-id="element-340">
              Satisfacción Total
            </span>
          </h2>
          <p className="text-xl text-gray-600" data-id="element-341">
            Probalo 7 días. Si no cumple tus expectativas, te devolvemos el
            100%. Sin preguntas.
          </p>
        </div>
      </section>

      {/* SECTION 13: TESTIMONIALS */}
      <section className="bg-gray-50 py-5 md:py-12 px-4" data-id="element-342">
        <div className="max-w-5xl mx-auto" data-id="element-343">
          <h2 className="text-3xl md:text-5xl font-bold text-center text-gray-900 mb-4 md:mb-8" data-id="element-344">
            <span className="text-[#22c55e]" data-id="element-345">Testimonios</span> de Docentes en
            Argentina
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 md:gap-4" data-id="element-346">
            {[{
            text: 'Mis alumnos ahora diseñan circuitos turísticos reales. El material es increíble y súper completo.',
            author: 'Romina S., 34 años',
            loc: 'Córdoba'
          }, {
            text: 'Antes perdía horas buscando material de turismo adaptado a Argentina. Ahora tengo todo organizado.',
            author: 'Gustavo M., 42 años',
            loc: 'Buenos Aires'
          }, {
            text: 'Las actividades sobre turismo sustentable enganchan a todos. Mis clases cambiaron por completo.',
            author: 'Silvia T., 51 años',
            loc: 'Mendoza'
          }, {
            text: 'El proyecto turístico escolar fue un éxito total. Los chicos presentaron trabajos increíbles.',
            author: 'Federico L., 36 años',
            loc: 'Salta'
          }, {
            text: 'Por fin un kit que cumple con los NAP y tiene ejemplos de destinos argentinos reales.',
            author: 'Carolina V., 44 años',
            loc: 'Rosario'
          }].map((t, i) => <div key={i} className="bg-white p-3 md:p-4 rounded-xl shadow-sm border border-gray-100" data-id="element-347">
                <div className="flex gap-1 text-yellow-400 mb-1.5 md:mb-2" data-id="element-348">
                  {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-current" data-id="element-349" />)}
                </div>
                <p className="text-gray-700 mb-1.5 md:mb-2 italic text-sm" data-id="element-350">
                  "{t.text}"
                </p>
                <div className="font-bold text-gray-900 text-sm" data-id="element-351">
                  {t.author} –{' '}
                  <span className="text-gray-500 font-normal" data-id="element-352">{t.loc}</span>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* SECTION 14: FAQ */}
      <section className="bg-white py-5 md:py-10 px-4" data-id="element-353">
        <div className="max-w-3xl mx-auto" data-id="element-354">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-4 md:mb-8" data-id="element-355">
            Preguntas{' '}
            <span className="text-[#22c55e] underline decoration-[#22c55e]/30 decoration-4 underline-offset-4" data-id="element-356">
              Frecuentes
            </span>
          </h2>

          <div className="space-y-1.5 md:space-y-2.5" data-id="element-357">
            {[{
            q: '¿En qué formato recibo el material?',
            a: 'Recibís todo en formato PDF, listo para descargar e imprimir o usar en formato digital.'
          }, {
            q: '¿Puedo imprimir el material?',
            a: 'Sí, podés imprimir todo el material las veces que necesites.'
          }, {
            q: '¿Para qué año de secundaria sirve?',
            a: 'El kit está diseñado para todos los años de secundaria donde se dicte Turismo.'
          }, {
            q: '¿Está alineado con los NAP 2026?',
            a: 'Sí, 100% alineado con los Núcleos de Aprendizajes Prioritarios 2026.'
          }, {
            q: '¿Necesito materiales especiales para usarlo?',
            a: 'No, solo necesitás una computadora o celular para descargar el material.'
          }, {
            q: '¿Cuánto tarda en llegar?',
            a: 'El acceso es inmediato. Apenas completás el pago, recibís el link de descarga en tu correo.'
          }, {
            q: '¿Sirve para diferentes materias de turismo?',
            a: 'Sí, cubre introducción, geografía, economía, sustentabilidad, planificación y proyectos turísticos.'
          }, {
            q: '¿Tiene garantía?',
            a: 'Sí, 7 días de garantía total. Si no te sirve, te devolvemos el 100%.'
          }, {
            q: '¿El acceso es permanente?',
            a: 'Sí, el acceso es de por vida sin vencimiento.'
          }, {
            q: '¿Funciona para todas las provincias argentinas?',
            a: 'Sí, el contenido es aplicable en todo el territorio nacional.'
          }].map((faq, i) => <details key={i} className="group bg-gray-50 rounded-lg border border-gray-200 open:bg-white open:shadow-md transition-all duration-200" data-id="element-358">
                <summary className="flex items-center justify-between cursor-pointer p-4 md:p-6 font-bold text-gray-900 list-none" data-id="element-359">
                  {faq.q}
                  <ChevronDown className="w-5 h-5 text-gray-500 group-open:rotate-180 transition-transform" data-id="element-360" />
                </summary>
                <div className="px-4 pb-4 md:px-6 md:pb-6 text-gray-600 leading-relaxed border-t border-gray-100 pt-4" data-id="element-361">
                  {faq.a}
                </div>
              </details>)}
          </div>
        </div>
      </section>

      {/* SECTION 15: FINAL CTA */}
      <section className="bg-black text-white py-5 md:py-12 px-4 text-center" data-id="element-362">
        <div className="max-w-4xl mx-auto" data-id="element-363">
          <h2 className="text-3xl md:text-5xl font-black mb-1.5 md:mb-3" data-id="element-364">
            ¿Listo/a para{' '}
            <span className="text-[#22c55e] underline decoration-[#22c55e]/30 decoration-4 underline-offset-8" data-id="element-365">
              transformar tu año
            </span>{' '}
            en Turismo?
          </h2>
          <p className="text-xl text-gray-400 mb-3 md:mb-6" data-id="element-366">
            Sumate a docentes que ya dejaron de improvisar.
          </p>

          <p className="text-gray-500 font-bold uppercase tracking-widest text-sm" data-id="element-367">
            📈 KIT COMPLETO TURISMO LISTA
          </p>
        </div>
      </section>

      {/* SECTION 15.5: BOTTOM PRICING (duplicate) */}
      <section className="py-5 md:py-12 px-4" style={{
      background: 'linear-gradient(180deg, #080c1a 0%, #0d1229 50%, #080c1a 100%)'
    }} data-id="element-368">
        <div className="max-w-5xl mx-auto" data-id="element-369">
          <h2 className="text-3xl md:text-5xl font-black text-white text-center mb-4 md:mb-8 italic" data-id="element-370">
            Elegí tu{' '}
            <span className="text-[#22c55e] underline decoration-[#22c55e]/30 decoration-4 underline-offset-8" data-id="element-371">
              Pack Completo
            </span>
          </h2>

          {/* Pack Cards - 3 Options */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 mb-6 md:mb-10 max-w-5xl mx-auto" data-id="element-372">
            {/* Bottom Card 0: Kit Turismo - remove badge */}
            <button onClick={() => setSelectedPack(0)} className={`relative text-left rounded-xl p-4 md:p-5 transition-all duration-200 cursor-pointer ${selectedPack === 0 ? 'bg-[#111633] border-2 border-[#22c55e] shadow-[0_0_20px_rgba(34,197,94,0.15)]' : 'bg-[#0d1025] border-2 border-[#1e2a5a] hover:border-[#2a3a6a]'}`} data-id="element-373">
              <div className={`absolute top-3 right-3 w-5 h-5 rounded-full border-2 flex items-center justify-center ${selectedPack === 0 ? 'border-[#22c55e] bg-[#22c55e]' : 'border-gray-600'}`} data-id="element-374">
                {selectedPack === 0 && <Check className="w-3 h-3 text-white" data-id="element-375" />}
              </div>
              <div className="text-2xl mb-1" data-id="element-376">✈️</div>
              <h3 className="text-base md:text-lg font-black text-white mb-0.5 pr-6" data-id="element-377">
                KIT COMPLETO DE TURISMO
              </h3>
              <p className="text-gray-500 text-[10px] md:text-xs mb-2" data-id="element-378">
                Para Docentes de Secundaria Argentina — Edición 2026
              </p>
              <ul className="space-y-1 mb-2" data-id="element-379">
                <li className="flex items-start gap-1.5 text-gray-300 text-[10px] md:text-xs" data-id="element-380">
                  <Check className="w-3.5 h-3.5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-381" />
                  6 Tomos completos
                </li>
                <li className="flex items-start gap-1.5 text-gray-300 text-[10px] md:text-xs" data-id="element-382">
                  <Check className="w-3.5 h-3.5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-383" />
                  3 Bonus incluidos
                </li>
                <li className="flex items-start gap-1.5 text-gray-300 text-[10px] md:text-xs" data-id="element-384">
                  <Check className="w-3.5 h-3.5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-385" />
                  Acceso Inmediato
                </li>
              </ul>
              <div className="flex items-baseline gap-2" data-id="element-386">
                <span className="text-2xl md:text-4xl font-black text-white" data-id="element-387">
                  $19.990
                </span>
              </div>
              <span className="text-gray-600 text-xs line-through" data-id="element-388">
                $39.990
              </span>
            </button>

            {/* Bottom Card 1: Pack Premium */}
            <button onClick={() => setSelectedPack(1)} className={`relative text-left rounded-xl p-4 md:p-5 transition-all duration-200 cursor-pointer ${selectedPack === 1 ? 'bg-[#111633] border-2 border-[#22c55e] shadow-[0_0_20px_rgba(34,197,94,0.15)]' : 'bg-[#0d1025] border-2 border-[#1e2a5a] hover:border-[#2a3a6a]'}`} data-id="element-389">
              <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-blue-600 text-white text-[10px] md:text-xs font-bold px-2.5 py-0.5 rounded-full uppercase tracking-wider whitespace-nowrap shadow-lg" data-id="element-390">
                Oferta especial
              </span>
              <div className={`absolute top-3 right-3 w-5 h-5 rounded-full border-2 flex items-center justify-center ${selectedPack === 1 ? 'border-[#22c55e] bg-[#22c55e]' : 'border-gray-600'}`} data-id="element-391">
                {selectedPack === 1 && <Check className="w-3 h-3 text-white" data-id="element-392" />}
              </div>
              <div className="text-2xl mb-1" data-id="element-393">👑</div>
              <h3 className="text-base md:text-lg font-black text-white mb-0.5 pr-6" data-id="element-394">
                KIT COMPLETO + PROYECTO TURÍSTICO 2026
              </h3>
              <p className="text-gray-500 text-[10px] md:text-xs mb-2" data-id="element-395">
                6 Tomos + 3 Bonus + Proyectos Turísticos
              </p>
              <ul className="space-y-1 mb-2" data-id="element-396">
                <li className="flex items-start gap-1.5 text-gray-300 text-[10px] md:text-xs" data-id="element-397">
                  <Check className="w-3.5 h-3.5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-398" />
                  6 Tomos completos
                </li>
                <li className="flex items-start gap-1.5 text-gray-300 text-[10px] md:text-xs" data-id="element-399">
                  <Check className="w-3.5 h-3.5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-400" />
                  3 Bonus incluidos
                </li>
                <li className="flex items-start gap-1.5 text-gray-300 text-[10px] md:text-xs" data-id="element-401">
                  <Check className="w-3.5 h-3.5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-402" />
                  Sistema de Proyectos Turísticos
                </li>
              </ul>
              <div className="flex items-baseline gap-2" data-id="element-403">
                <span className="text-2xl md:text-4xl font-black text-white" data-id="element-404">
                  $27.990
                </span>
              </div>
              <span className="text-gray-600 text-xs line-through" data-id="element-405">
                $49.990
              </span>
            </button>

            {/* Card 2: Pack Premium + Hotelería */}
            <button onClick={() => setSelectedPack(2)} className={`relative text-left rounded-xl p-5 md:p-8 transition-all duration-200 cursor-pointer ${selectedPack === 2 ? 'bg-[#111633] border-2 border-[#22c55e] shadow-[0_0_20px_rgba(34,197,94,0.15)]' : 'bg-[#0d1025] border-2 border-[#1e2a5a] hover:border-[#2a3a6a]'}`} data-id="element-406">
              <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-red-600 text-white text-[10px] md:text-sm font-bold px-3 py-1 rounded-full uppercase tracking-wider whitespace-nowrap shadow-lg" data-id="element-407">
                🔥 Pack Premium +
              </span>
              <div className={`absolute top-4 right-4 w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex items-center justify-center ${selectedPack === 2 ? 'border-[#22c55e] bg-[#22c55e]' : 'border-gray-600'}`} data-id="element-408">
                {selectedPack === 2 && <Check className="w-3 h-3 md:w-4 md:h-4 text-white" data-id="element-409" />}
              </div>
              <div className="text-3xl mb-2" data-id="element-410">💎</div>
              <h3 className="text-lg md:text-2xl font-black text-white mb-1 pr-6" data-id="element-411">
                KIT COMPLETO TURISMO + KIT COMPLETO HOTELERÍA
              </h3>
              <p className="text-gray-500 text-xs md:text-sm mb-3" data-id="element-412">
                Todo el Kit Completo de Turismo + Hotelería Lista
              </p>
              <ul className="space-y-2 mb-4" data-id="element-413">
                <li className="flex items-start gap-2 text-gray-300 text-xs md:text-sm" data-id="element-414">
                  <Check className="w-4 h-4 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-415" />
                  12 Tomos completos
                </li>
                <li className="flex items-start gap-2 text-gray-300 text-xs md:text-sm" data-id="element-416">
                  <Check className="w-4 h-4 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-417" />
                  4 Bonus incluidos
                </li>
                <li className="flex items-start gap-2 text-gray-300 text-xs md:text-sm" data-id="element-418">
                  <Check className="w-4 h-4 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-419" />
                  2 Upsell exclusivos
                </li>
              </ul>
              <div className="flex items-baseline gap-2" data-id="element-420">
                <span className="text-3xl md:text-5xl font-black text-white" data-id="element-421">
                  $38.990
                </span>
              </div>
              <span className="text-gray-600 text-sm line-through" data-id="element-422">
                $59.990
              </span>
            </button>
          </div>

          {/* CTA Button */}
          <div className="text-center mb-4 md:mb-6" data-id="element-423">
            <a href={packLinks[selectedPack]} className="inline-flex items-center justify-center gap-2 w-full md:w-auto bg-[#22c55e] hover:bg-[#16a34a] text-white font-black text-xl md:text-3xl py-4 px-8 md:py-5 md:px-16 rounded-xl shadow-[0_0_30px_rgba(34,197,94,0.3)] transform hover:scale-[1.02] transition-all duration-200" data-id="element-424">
              Sí, quiero mi pack →
            </a>
            <p className="text-gray-500 text-sm md:text-base font-medium mt-2 flex items-center justify-center gap-2" data-id="element-425">
              <Lock className="w-4 h-4" data-id="element-426" /> PAGO SEGURO CON MERCADO PAGO
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 16: FOOTER */}
      <footer className="bg-gray-900 text-gray-500 py-3 md:py-6 px-4 text-center text-sm border-t border-gray-800" data-id="element-427">
        <p className="mb-1.5 md:mb-3" data-id="element-428">© 2026 Kit Completo Turismo Lista™</p>
        <div className="flex justify-center gap-4" data-id="element-429">
          <span className="hover:text-white cursor-pointer" data-id="element-430">Términos</span>
          <span className="hover:text-white cursor-pointer" data-id="element-431">Privacidad</span>
          <span className="hover:text-white cursor-pointer" data-id="element-432">Soporte</span>
        </div>
      </footer>
    </div>;
}